"use strict";

exports.__esModule = true;
exports.DeviceContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides a list of devices to consumers.
 * @component
 */
var DeviceContext = exports.DeviceContext = (0, _Utils.createEnhancedContext)({
  propName: "device"
});